// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"352":"4f7eb9fa","374":"d0bdd557","396":"7328006f","426":"fe0c165c","576":"f38a4c0c","636":"9c04bfc7","729":"831fd46f","787":"9301218e","965":"0d7ae181"}[chunkId] + ".chunk.js";
};